// extracted by mini-css-extract-plugin
export default {"header":"Header_header__co-Il","subheader":"Header_subheader__RYUEw","floating":"Header_floating__nlmvW"};